export default __webpack_public_path__ + "static/media/Frame 9.f66048d1.svg";